import { Autocomplete, Chip, TextField } from '@mui/material';
import { Box } from '@mui/system';
import type { PermissionFunctionGroup } from '../../types/permissions';

interface PermissionFunctionGroupSelectProps {
	editing: boolean;
	value: PermissionFunctionGroup['functionGroup'][];
	options: PermissionFunctionGroup['functionGroup'][];
	onChange: (e, value) => void;
}

export const PermissionFunctionGroupSelect = ({
	editing,
	value,
	options,
	onChange,
}: PermissionFunctionGroupSelectProps) => {
	if (editing) {
		return (
			<Autocomplete
				options={options}
				value={value}
				multiple
				size='small'
				sx={{ width: '100%' }}
				filterSelectedOptions
				isOptionEqualToValue={(option, val) => option.name === val.name}
				getOptionLabel={(option) => option.description}
				getOptionKey={(option) => option.name}
				renderInput={(params) => (
					<TextField
						{...params}
						variant='standard'
						placeholder=''
						InputProps={{
							...params.InputProps,
							sx: {
								minHeight: '40px',
								'& .MuiAutocomplete-clearIndicator': {
									display: 'none',
								},
								'&::before': {
									borderBottom: 'none !important',
								},
								'&::after': {
									borderBottom: 'none !important',
								},
							},
						}}
					/>
				)}
				onChange={onChange}
			/>
		);
	}

	return (
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
			{value.map(({ name, description }) => (
				<Chip key={name} label={description} size='small' />
			))}
		</Box>
	);
};
